export default "__VITE_ASSET__mHT07zgk__"